// GST treatment is stored as 'registered_b2b' | 'unregistered_b2c' — those
// values drive billing GST splits + GSTIN validation, so they don't change.
// The UI simply presents whether the entity is GST registered or not.
export function gstTreatmentLabel(value: string | null | undefined): string {
  return value === "registered_b2b" ? "GST Registered" : "Not Registered";
}

// Phase 57 (financial core) — carried forward verbatim from the legacy
// pages/expenses.tsx (₹ + en-IN, 2 decimals) so every money figure across
// the expense/ledger surfaces formats identically. Money from the API
// arrives as `number` (OpenAPI declares `format: double`); this coerces
// defensively for the rare case a caller still hands it a numeric string.
export function inr(n: number | string | null | undefined): string {
  return `₹${(Number(n) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// 'YYYY-MM-DD' for today, UTC-safe for a date-only input default.
export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

// Same rounding the ledger/expense server routes use (round2 in
// @workspace/ledger) — kept local here so the UI's LIVE preview totals use
// the identical rounding rule as the server that will recompute them.
export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function maskMobileNumber(input: string | null | undefined): string {
  if (!input) return "";
  const digits = String(input).replace(/[^\d]/g, "");
  if (digits.length < 5) return input;
  const head = digits.slice(0, 2);
  const tail = digits.slice(-2);
  const middleLen = digits.length - 4;
  return `${head}${"x".repeat(middleLen)}${tail}`;
}
